import { render, staticRenderFns } from "./WhsPL.vue?vue&type=template&id=3f094dd9"
import script from "./WhsPL.vue?vue&type=script&lang=js"
export * from "./WhsPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports